import { getPayments, Payment, addPayment, updatePayment, chargePayment } from '../api/payments';
import { updatePayments, updateSinglePayment } from './store/app-actions';
import { store } from '../store';

export const getPaymentsAndUpdateStore = async (page: number) => {
	page = page > 0 ? page : 1;

	const result = await getPayments(page, 10);

	store.dispatch(updatePayments(result.data, result.paginationPage, result.paginationCount));
};

// Refreshing the list after an action must not report the action itself as
// failed (e.g. the guest would get a second request email on resubmit)
const refreshPaymentsSafely = async () => {
	try {
		await getPaymentsAndUpdateStore(store.getState().paymentPage);
	} catch (e) {
		console.error(e);
	}
};

export const addPaymentAndUpdateStore = async (payment: Payment) => {
	await addPayment(payment);
	await refreshPaymentsSafely();
};

export const updatePaymentAndUpdateStore = async (id: string, data: Payment) => {
	await updatePayment(id, data);
	await refreshPaymentsSafely();
};

export const chargePaymentAndUpdateStore = async (id: string, amount: number, description: string) => {
	const payment = await chargePayment(id, amount, description);
	await refreshPaymentsSafely();

	return payment;
};
